import {
  QuestionnaireResponse,
  QuestionResponseData
} from '../jobs/questionnaireresponse';

export class SurveyDetailRequest {
  public userId: number = 0;
  public surveyId: string = '';
  public surveyUserQualifierId: string = '';
  public questionID: number | undefined = undefined;
  public navigation: string= '';
  public answerIds: Array<number> = []
}

// tslint:disable-next-line:max-classes-per-file
export class SurveyDetailResponse {
  public survey: Survey = new Survey();
  public questionnaireResponse: QuestionnaireResponse = new QuestionnaireResponse();
  public surveyUserQualifierId: string = '';
  public surveyMessage: string = '';
}

// tslint:disable-next-line:max-classes-per-file
export class Survey {
  public surveyId: number = 0;
  public surveyName: string = '';
  public commonJobInfo: string = '';
  public surveyTypeValue: string = '';
  public surveyTypeDesc: string = '';
  public surveyStatus: string = '';
  public surveySentDate: string = '';
  public companyProfile: string = '';
}

// tslint:disable-next-line:max-classes-per-file
export class SurveyQuestionResponse {
  public userId: number = 0;
  public surveyId: string = '';
  public surveyUserQualifierId: string = '';
  public numberOfQuestions: number = 0;
  public hasAnsweredAll: boolean = false;
  //public submit : boolean = false;  //dont send this parameter to back end
  public questionResponseData: QuestionResponseData[] = [];
}

export class SurveyListRequest {
  public sessionToken!: string;
  public resultSize: number = 0;
  public resultPage: number = 0;
}

export class SurveyFieldValidation {
  public companyID: number = 0;
  public attributeKey: string = '';
  public locale:string = 'en-US';
  public value : string = '';
  public values :string[] = [];
}
